import { render, staticRenderFns } from "./closedSpaceEduAssess.vue?vue&type=template&id=a26b93e2"
import script from "./closedSpaceEduAssess.vue?vue&type=script&lang=js"
export * from "./closedSpaceEduAssess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a26b93e2')) {
      api.createRecord('a26b93e2', component.options)
    } else {
      api.reload('a26b93e2', component.options)
    }
    module.hot.accept("./closedSpaceEduAssess.vue?vue&type=template&id=a26b93e2", function () {
      api.rerender('a26b93e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/closedSpaceEduAssess.vue"
export default component.exports